import React from 'react'
import styles from './Photos.scss'
import {urls} from 'lib/urls'
import {showGallery} from 'features/gallery/showGallery'
import {IntroWidget} from 'common/IntroWidget'
import fetchJSON from 'lib/fetchJSON'

export class Photos extends React.PureComponent {
  loadAndShowGallery = (activePhotoId = null) => {
    const {currentUser} = this.props
    fetchJSON(`/users/${currentUser.id}/photos.json?limit=250`)
      .then(({photos}) => {
        showGallery({photos, activePhotoId: activePhotoId, readonly: true})
      })
  }

  render () {
    const {photos} = this.props

    if (photos.length === 0) {
      return (
        <IntroWidget
          large
          i='ios-images'
          link={<a href='https://ridewithgps.com/help/add-photos-to-a-ride-or-route' target='_blank'>Learn How to Upload Photos</a>}>
          You haven't uploaded any photos yet.
        </IntroWidget>
      )
    }

    // With sidebar in default state, thumbs are
    // 295px on a 1920px display
    // 135px on a 13" laptop display
    // 73px on an iPhone
    // since the closest thing we've got to all of these right now is the
    // 160px size, I'm going to punt on doing a srcSet implementation until
    // we have imgproxy available in prod
    return (
      <div>
        <div className={styles.Photos}>
          {photos.slice(0, 8).map(p => <div className={styles.photo} key={p.id}>
            <img
              onClick={() => this.loadAndShowGallery(p.id)}
              src={urls.photos.profile(p.id)} />
          </div>)}
        </div>
        <div>
          <a onClick={() => this.loadAndShowGallery()} data-card-link>View Photos</a>
        </div>
      </div>
    )
  }
}
